<h1 class="ap-blue">{{'ml_144073' | translate }}</h1>

@if(!(commonDataLoading$ | async)) {
<app-smart-search-form [defaultSearchCriteria$]="defaultSearchCriteria$" [formPath]="formPath" [searchByList]="driverDataSearchByList$ | async" [onSearch]="onSearch"
  [searching$]="searching$"></app-smart-search-form>

<div class="row ms-0 mb-2">
  <div class="col p-0">
    <button (click)="onEdit()" [disabled]="selectedItems.length !== 1" class="button--default">{{ 'ml_143925' | translate }}</button>
  </div>
</div>
}

<app-message-data [errorMsg$]="errorMessage$"></app-message-data>

<app-data-grid [isServerSidePagingFiltering]="true" [onLoadServerSideData]="onGetData" [totalCountForServerSidePagingFiltering$]="totalCount$"
  [isLoading]="(searching$ | async) || (commonDataLoading$ | async)" [dataSource$]="dataSource$" [defaultPageFilterSetting]="currentPageFilterSetting$ | async" [columnsDef]="dataGridColumnDef"
  [enableRowSelect]="true" (rowSelected)="rowSelected($event)">
  <ng-template #cellContent let-data="data" let-column="column">
    <app-driver-data-data-grid-cell [data]="data" [field]="column.name" [column]="column"></app-driver-data-data-grid-cell>
  </ng-template>
</app-data-grid>

